type QueryTouchSwipeRecognizerStopEvent = "left" | "right" | "top" | "bottom" | "none";

interface IQueryTouchSwipeRecognizerConfig 
    extends IQueryTouchRecognizerConfig {
    // px per ms
    velocity: number;        
}

interface QueryTouchSwipeRecognizerMoveEvent {
    movedX: number;
    movedY: number;
}
class QueryTouchSwipeRecognizer
    extends QueryTouchRecognizer<IQueryTouchSwipeRecognizerConfig> {
    
    private readonly _start = new QueryEventAsync<void>();
    private readonly _move = new QueryEventAsync<QueryTouchSwipeRecognizerMoveEvent>();
    private readonly _stop = new QueryEventAsync<QueryTouchSwipeRecognizerStopEvent>();

    public get startEvent() { return this._start.expose(); };
    public get moveEvent() { return this._move.expose(); };
    public get stopEvent() { return this._stop.expose(); };

    constructor(config: IQueryTouchSwipeRecognizerConfig) {
        super(config);
    }
    isFulfilled(start: QueryTouchDetails, current: QueryTouchDetails) {
        if(current.touches.length != this.config.pointers)
            return false;
        
        let event = this.getEvent(start, current);
        let absMovedX = Math.abs(event.movedX);
        let absMovedY = Math.abs(event.movedY);

        if(absMovedX >= this.config.threshold)
            return absMovedX > absMovedY 
                && ((this.config.direction ^ QueryTouchDirection.X) == 0);
        else if (absMovedY >= this.config.threshold)
            return absMovedY > absMovedX 
                &&(this.config.direction ^ QueryTouchDirection.Y) == 0;

        return null;
    }

    async onStart(start: QueryTouchDetails) {
        await this._start.trigger(undefined);
    }
    async onMove(start: QueryTouchDetails, current: QueryTouchDetails) {
        await this._move.trigger(this.getEvent(start, current));
    }
    async onStop(start: QueryTouchDetails, stop: QueryTouchDetails) {
        let event = this.getEvent(start, stop);
        
        let duration = stop.time - start.time;

        let velocityX = event.movedX / duration;
        let absVelocityX = Math.abs(velocityX);

        let velocityY = event.movedY / duration;
        let absVelocityY = Math.abs(velocityY);

        if((this.config.direction ^ QueryTouchDirection.Y) == 0 && (this.config.direction ^ QueryTouchDirection.X) == 0) {
            if(Math.max(absVelocityX, absVelocityY) > this.config.velocity) {
                return this._stop.trigger(absVelocityX > absVelocityY ? 
                    (velocityX > 0 ? "right" : "left") : 
                    (velocityY > 0 ? "bottom" : "top")
                );
            }
        } else if ((this.config.direction ^ QueryTouchDirection.X) == 0) {
            if (absVelocityX > this.config.velocity) {
                return this._stop.trigger(velocityX > 0 ? "right" : "left");
            }
        } else if ((this.config.direction ^ QueryTouchDirection.Y) == 0) {
            if (absVelocityY > this.config.velocity) {
                return this._stop.trigger(velocityY > 0 ? "bottom" : "top");
            }
        }

        return this._stop.trigger("none");
    }

    private getEvent(start: QueryTouchDetails, stop: QueryTouchDetails): QueryTouchSwipeRecognizerMoveEvent {
        let currTouch = stop.touches[0];
        let startTouch = start.touches[0];

        return {
            movedX: currTouch.x - startTouch.x,
            movedY: currTouch.y - startTouch.y
        }
    }
}